import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { openListing } from '../containers/ManageListingsPage/ManageListingsPage.duck';
import { checkIfHorseHasNoAssets } from '../components/ManageListingCard/helpers';
import { LISTING_PAGE_PARAM_TYPE_EDIT, PHOTOS } from '../components/EditListingWizard/config';
import { getListingNavParams } from '../util/listings';
import { createResourceLocatorString, EDIT_LISTING_PAGE } from '../util/routes';
import routeConfiguration from '../routeConfiguration';

/**
 * Reactivate a closed own listing. Listings closed by the system due to missing
 * gallery assets are not reopened, the owner is redirected to the gallery tab instead
 * @param {object} listing - sdk listing
 * @returns {() => Promise<void>} - reactivation handler
 */
export const useReactivateListing = listing => {
    const history = useHistory();
    const dispatch = useDispatch();

    const listingId = listing?.id?.uuid;
    /** Public listing entities have no privateData, own entities are used instead */
    const ownListing = useSelector(s => {
        const allListings = s['ManageListingsPage']?.ownEntities?.ownListing;
        return allListings ? allListings[listingId] : null;
    });

    return async () => {
        if (checkIfHorseHasNoAssets(ownListing)) {
            const { params } = getListingNavParams(listing);
            return history.push(
                createResourceLocatorString(
                    EDIT_LISTING_PAGE,
                    routeConfiguration(),
                    {
                        ...params,
                        type: LISTING_PAGE_PARAM_TYPE_EDIT,
                        tab: PHOTOS,
                    },
                    {}
                )
            );
        }
        await dispatch(openListing(listingId));
        window.location.reload();
    };
};
